import { get, throttle } from "lodash";
import { initEnquiryForm, EnquiryConfig } from "./enquiry-form";
import {
    initSingleEnquiryFormPopupStates,
    initProductSupplierContactForm,
    initProductSliderEnquiryPopupButtons,
} from "./single-helpers";

declare const jQuery: any;
const $ = jQuery;

const onLargeScreen: Function = window["iw"].breakpoints.onLargeScreen;

export function initProductSingle(): void
{
    if (!$(document.body).hasClass("single-hs_product"))
    {
        return;
    }
    const productTitle: string = get(window, "iw.productPostTitle");
    const defaultMsg: string = productTitle ? `Enquiry about ${productTitle}: ` : ``;
    initProductEnquiryProduct(defaultMsg);
    initGallery();
    initSingleEnquiryFormPopupStates();
    initProductSupplierContactForm();
    initProductSliderEnquiryPopupButtons();
}

function initProductEnquiryProduct(defaultMsg: string): void
{
    const $button = $(`[data-enquiry-popup-btn]`);
    if ($button.length === 0)
    {
        return;
    }
    const postId: number = parseInt($button.attr("data-enquiry-popup-btn"), 10);
    const postType = "product";
    const config: EnquiryConfig = {
        postId,
        postType
    };
    const $enquiryPopup = $(`[data-popup="enquiry"]`);
    const $formWrap = $enquiryPopup.find(`.hs-enquiry-form`);
    if ($enquiryPopup.length === 0)
    {
        console.error(`Missing [data-popup="enquiry"]`);
        return;
    }
    $button.on("click", function (event) {
        initEnquiryForm($formWrap, config, defaultMsg);
        $enquiryPopup.trigger("open");
        return false;
    });
}

function initGallery(): void
{
    const $mainImages = $(`.gallery-main-image .image`);
    const $thumbsWrap = $(`.gallery-thumbs`);
    const $thumbs = $thumbsWrap.find(`.thumb`);
    $thumbs.on("click", function (event) {
        const $thumb = $(this);
        const index: number = $thumb.index();
        $mainImages.removeClass("show").eq(index).addClass("show");
        $thumbs.removeClass("selected");
        $thumb.addClass("selected");
        return false;
    });
    initGalleryNav($thumbsWrap);
}

function initGalleryNav($thumbsWrap): void
{
    if ("ontouchstart" in window)
    {
        return;
    }
    
    const $scrolly = $thumbsWrap.find(`.gallery-thumbs-scrolly`);

    if ($scrolly.length === 0)
    {
        return;
    }

    const SLIDE_DURATION = 250;

    // NB. on large screen, we are doing vertical scrolling; else, horiz.
	const getPixelDistance = (): number => {
        if (onLargeScreen())
        {
            return $scrolly.outerHeight(false) / 1.5;
        }
        return $scrolly.outerWidth(false) / 1.5;
    };
    const $prev = $(`<div class="ctrl ctrl-prev hide">`).appendTo($thumbsWrap);
    const $next = $(`<div class="ctrl ctrl-next hide">`).appendTo($thumbsWrap);
    const hideShowButtons = () => {
        const lg: boolean = onLargeScreen();
		const x: number = lg ? $scrolly.scrollTop() : $scrolly.scrollLeft();
		if (x < 5)
		{
			$prev.addClass("hide");
		}
		else
		{
			$prev.removeClass("hide");
		}
        const shouldHideNext: boolean = lg ?
            (x + $scrolly.innerHeight() >= ($scrolly[0].scrollHeight) - 5) :
            (x + $scrolly.innerWidth() >= ($scrolly[0].scrollWidth) - 5);
		if (shouldHideNext)
		{
			$next.addClass("hide");
		}
		else
		{
			$next.removeClass("hide");
		}
	};
	$scrolly.on("scroll", throttle(hideShowButtons));
	$prev.on("click", function () {
        const lg: boolean = onLargeScreen();
        const px: number = getPixelDistance();
		const d: number = lg ?
            $scrolly.scrollTop() - px :
            $scrolly.scrollLeft() - px;
		$scrolly['scrollTo'](d, SLIDE_DURATION, { axis: lg ? "y" : "x" });
		hideShowButtons();
	});
	$next.on("click", function () {
        const lg: boolean = onLargeScreen();
        const px: number = getPixelDistance();
		const d: number = lg ?
            px + $scrolly.scrollTop() :
            px + $scrolly.scrollLeft();
		$scrolly['scrollTo'](d, SLIDE_DURATION, { axis: lg ? "y" : "x" });
		hideShowButtons();
	});
	hideShowButtons();
    $(window).on("resize", throttle(function () {
        hideShowButtons();
    }, 150, { trailing: true }));
}
